/* Terjung layout hardening. Source: migrated from layout/theme.liquid static inline blocks. */

/* terjung-accessibility-commerce-patch-js */
document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.bkt-card__stars[aria-label]').forEach(function (element) {
        if (!element.hasAttribute('role')) {
          element.setAttribute('role', 'img');
        }
      });
      document.querySelectorAll('li.submenu-back > a:not([href])').forEach(function (anchor) {
        anchor.setAttribute('href', '#');
        anchor.setAttribute('role', 'button');
        anchor.addEventListener('click', function (event) {
          event.preventDefault();
        });
      });
      document.querySelectorAll('[aria-controls]').forEach(function (element) {
        var id = element.getAttribute('aria-controls');
        if (id && !document.getElementById(id)) {
          element.removeAttribute('aria-controls');
        }
      });
    });

/* terjung-remove-legacy-fake-reviews-js */
(function () {
      function removeLegacyReviews() {
        document.querySelectorAll('#bk-testimonials, [id*="__custom_liquid_jb7aiQ"]').forEach(function (element) {
          var section = element.closest('.shopify-section') || element;
          section.remove();
        });
      }
      document.addEventListener('DOMContentLoaded', removeLegacyReviews);
      window.addEventListener('load', removeLegacyReviews);
      if ('MutationObserver' in window) {
        new MutationObserver(removeLegacyReviews).observe(document.documentElement, { childList: true, subtree: true });
      }
    })();

/* terjung-drawer-hero-code-text-override */
(() => {
    const applyTerjungDrawerCodeText = () => {
      document.querySelectorAll('#site-menu-sidebar .terjung-drawer-hero__code').forEach((button) => {
        button.textContent = 'Code TERJUNG5';
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyTerjungDrawerCodeText, { once: true });
    } else {
      applyTerjungDrawerCodeText();
    }
    document.addEventListener('click', applyTerjungDrawerCodeText, true);
  })();

/* terjung-header-product-category-rail-hardening-js */
(() => {
    const removeSticky = () => {
      if (document.body && document.body.classList.contains('terjung-header-top-stuck')) {
        document.body.classList.remove('terjung-header-top-stuck');
      }
      document.querySelectorAll('.sticky-header, #site-header .terjung-header-top-spacer').forEach((node) => node.remove());
    };
    const moveRailIntoHeader = () => {
      const header = document.getElementById('site-header');
      const rail = document.querySelector('[data-terjung-product-category-rail]');
      if (!header || !rail || rail.closest('#site-header') === header) return;
      header.appendChild(rail);
    };
    const harden = () => {
      window.requestAnimationFrame(() => {
        moveRailIntoHeader();
        removeSticky();
      });
      [0, 80, 240, 520].forEach((delay) => window.setTimeout(() => {
        moveRailIntoHeader();
        removeSticky();
      }, delay));
    };
    const install = () => {
      harden();
      window.addEventListener('scroll', harden, { passive: true });
      window.addEventListener('resize', harden);
      window.addEventListener('orientationchange', harden);
      new MutationObserver(harden).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      window.setInterval(harden, 240);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', install, { once: true });
    } else {
      install();
    }
  })();

/* terjung-layout-static-inline-js-start */
(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const setTouchClass = () => {
    const body = document.body;
    if (!body) return;
    if ('ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch)) {
      body.classList.remove('no-touchevents');
      body.classList.add('touchevents');
    }
  };

  const syncCartEmptyState = () => {
    const cart = document.getElementById('cart');
    const sidebar = document.getElementById('site-cart-sidebar');
    if (!cart || !sidebar) return;
    sidebar.classList.toggle('cart-is-empty', cart.classList.contains('cart--empty'));
  };

  const installCartObserver = () => {
    const cartForm = document.querySelector('.cart-form');
    syncCartEmptyState();
    if (!cartForm || !('MutationObserver' in window)) return;
    new MutationObserver(syncCartEmptyState).observe(cartForm, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  };

  const syncGoTopState = () => {
    const goTop = document.getElementById('go-top');
    if (!goTop) return;
    goTop.classList.toggle('show', window.scrollY > 100);
  };

  const clearRteImageLinkBorders = () => {
    document.querySelectorAll('.rte a img').forEach((image) => {
      if (image.parentNode) image.parentNode.style.border = 'none';
    });
  };

  onReady(() => {
    setTouchClass();
    installCartObserver();
    syncGoTopState();
    clearRteImageLinkBorders();
  });
  window.addEventListener('scroll', syncGoTopState, { passive: true });
  window.addEventListener('load', clearRteImageLinkBorders);
})();
/* terjung-layout-static-inline-js-end */
